import { gql } from '@apollo/client'

import { STATUS } from 'features/Changes/components/Status/constants'

export const isScheduled = (change: TSFixMe): TSFixMe => {
  return change.status === STATUS.SCHEDULED
}

export const flattenChanges = (changes: TSFixMe): TSFixMe => {
  return changes.reduce((result: TSFixMe, change: TSFixMe): TSFixMe => {
    return [
      ...result,
      ...change.changes.map((nestedChange: TSFixMe): TSFixMe => {
        return {
          ...nestedChange,
          id: change.id
        }
      })
    ]
  }, [])
}

export const resolvers = {
  Mutation: {
    cancelChange(_root: TSFixMe, { changeId }: TSFixMe, { cache }: TSFixMe) {
      const data = cache.readFragment({
        id: cache.identify({
          __typename: 'ScheduledChangesResponseItems',
          id: changeId
        }),
        fragment: gql`
          fragment ScheduledChanges on ScheduledChangesResponseItems {
            changes {
              executeAt
              status
              statusChanges {
                status
                changedAt
              }
              type
              user {
                id
                firstName
                lastName
                username
              }
            }
          }
        `
      })

      const newChanges = data.changes.map((change: TSFixMe): TSFixMe => {
        if (change.status === STATUS.SCHEDULED) {
          return {
            ...change,
            status: STATUS.CANCELLED,
            statusChanges: [
              ...change.statusChanges,
              {
                status: STATUS.CANCELLED,
                changedAt: new Date()
              }
            ]
          }
        }

        return change
      })

      cache.writeFragment({
        id: cache.identify({
          __typename: 'ScheduledChangesResponseItems',
          id: changeId
        }),
        fragment: gql`
          fragment ScheduledChanges on ScheduledChangesResponseItems {
            changes {
              executeAt
              status
              statusChanges {
                status
                changedAt
              }
              type
              user {
                id
                firstName
                lastName
                username
              }
            }
          }
        `,
        data: {
          __typename: 'ScheduledChangesResponseItems',
          changes: newChanges
        }
      })

      return null
    }
  }
}
